export class DefaultResponse{
     public  message:string;
     public  viewName:string;
    public outputParam :Map<String,Object>;

}